import React from 'react';
import axios from 'axios';

export default axios.create({
   // baseURL: 'http://localhost/bolvirtualbackend/'
   baseURL: 'https://bolvirtual.cybermaq.com/bolvirtualbackend/'
});